export const ACTION_TYPES = {
	SET_VALIDATION_ERRORS: 'SET_VALIDATION_ERRORS',
	CLEAR_VALIDATION_ERROR: 'CLEAR_VALIDATION_ERROR',
	CLEAR_VALIDATION_ERRORS: 'CLEAR_VALIDATION_ERRORS',
	HIDE_VALIDATION_ERROR: 'HIDE_VALIDATION_ERROR',
	SHOW_VALIDATION_ERROR: 'SHOW_VALIDATION_ERROR',
	SHOW_ALL_VALIDATION_ERRORS: 'SHOW_ALL_VALIDATION_ERRORS',
} as const;
